import React, { ReactElement, ChangeEvent, useRef, RefObject } from "react";
import { FormikContextType } from "formik";
import { Column, CellInfo } from "react-table-6";
import { CheckBox } from "adviesbox-shared";
import classes from "./beschikbare-taxatiebureaus.module.scss";
import { TaxatiebureausState } from "../infra";
import classnames from "classnames";

export const EmptyComponent = (): null => null;

const createSpanWithId = (c: CellInfo): ReactElement => {
  return <span id={`${c.index}-row-partijnaam-taxatiebureaus`}>{c.original.partijnaam}</span>;
};

export const createActiveCheckboxCell = (c: CellInfo): ReactElement => {
  return (
    <div className={classes.clickable_label_fix}>
      <CheckBox
        name={`beschikbareTaxatiebureaus.partijen[${c.index}].actief`}
        caption=""
        disabled={c.original.code === "XX"}
      />
    </div>
  );
};

export const createTextInputAgentNummerCell = (
  formik: FormikContextType<TaxatiebureausState>
): ((c: CellInfo) => ReactElement) => (c: CellInfo): ReactElement => {
  const { values, setFieldValue } = formik;
  const inputElement: RefObject<HTMLInputElement> | null = useRef(null);

  const onMouseUp = (): void => {
    inputElement.current?.focus();
  };

  const onBlur = (e: ChangeEvent<HTMLInputElement>): void => {
    setFieldValue(`beschikbareTaxatiebureaus.partijen[${c.index}].agentnummer`, e.target.value);
  };

  return (
    <div className="input-group">
      <input
        data-testid={`agentnummer-input-${c.index}`}
        id={`agentnummer-input-${c.index}`}
        type="text"
        // ../../shared/components/tekst-input/TextInput.module.scss: input_control
        className={classnames("input_control", "grid-cell")}
        defaultValue={values.beschikbareTaxatiebureaus.partijen[c.index].agentnummer || ""}
        onBlur={onBlur}
        ref={inputElement}
        onMouseUp={onMouseUp}
      />
    </div>
  );
};

export const getColumns = (formik: FormikContextType<TaxatiebureausState>): Column[] => {
  return [
    {
      Header: "Partijnaam",
      Cell: createSpanWithId
    },
    {
      Header: "Actief",
      Cell: createActiveCheckboxCell,
      maxWidth: 100
    },
    {
      Header: "Agentnummer",
      Cell: createTextInputAgentNummerCell(formik)
    }
  ];
};
